interface FireIconProps {
  size?: number;
  className?: string;
  animated?: boolean;
}

export const FireIcon = ({ size = 24, className = '', animated = false }: FireIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${animated ? 'animate-pulse' : ''}`}
      style={{
        filter: 'drop-shadow(0 0 12px rgba(255, 255, 255, 1)) drop-shadow(0 0 20px rgba(255, 215, 0, 0.9)) drop-shadow(0 0 30px rgba(255, 165, 0, 0.7))',
      }}
    >
      <defs>
        {/* Enhanced gradient for flame - brighter colors */}
        <linearGradient id="flameGradient" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="20%" stopColor="#FFED4E" />
          <stop offset="40%" stopColor="#FFD700" />
          <stop offset="60%" stopColor="#FF8C00" />
          <stop offset="80%" stopColor="#FF4500" />
          <stop offset="100%" stopColor="#DC143C" />
        </linearGradient>

        {/* Brighter inner flame gradient */}
        <linearGradient id="innerFlameGradient" x1="50%" y1="0%" x2="50%" y2="100%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="30%" stopColor="#FFF9C4" />
          <stop offset="60%" stopColor="#FFD54F" />
          <stop offset="100%" stopColor="#FFB300" />
        </linearGradient>

        {/* Glow filter */}
        <filter id="fireGlow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>

      {/* Outer glow layer */}
      <path
        d="M12 2C12 2 8 6 8 10C8 13 10 15 12 15C14 15 16 13 16 10C16 6 12 2 12 2Z"
        fill="#FFD700"
        opacity="0.3"
        transform="scale(1.15 1.15)"
        style={{ transformOrigin: '12px 10px' }}
      />

      {/* Outer flame with stroke for contrast */}
      <path
        d="M12 2C12 2 8 6 8 10C8 13 10 15 12 15C14 15 16 13 16 10C16 6 12 2 12 2Z"
        fill="url(#flameGradient)"
        stroke="#FFFFFF"
        strokeWidth="0.5"
        filter="url(#fireGlow)"
      />

      {/* Middle flame */}
      <path
        d="M12 6C12 6 9.5 8.5 9.5 11C9.5 12.933 10.567 14 12 14C13.433 14 14.5 12.933 14.5 11C14.5 8.5 12 6 12 6Z"
        fill="url(#innerFlameGradient)"
        stroke="#FFFFFF"
        strokeWidth="0.3"
      />

      {/* Inner highlight - brighter and larger */}
      <ellipse
        cx="12"
        cy="9"
        rx="2.5"
        ry="4"
        fill="rgba(255, 255, 255, 0.9)"
      />

      {/* Base flame (bottom part) */}
      <path
        d="M8 14C8 14 6 16 6 18C6 20.209 8.343 22 11 22H13C15.657 22 18 20.209 18 18C18 16 16 14 16 14"
        fill="url(#flameGradient)"
        stroke="#FFFFFF"
        strokeWidth="0.5"
        opacity="0.95"
      />

      {/* Bottom flame detail */}
      <path
        d="M10 16C10 16 9 17 9 18.5C9 19.881 10.119 21 11.5 21H12.5C13.881 21 15 19.881 15 18.5C15 17 14 16 14 16"
        fill="url(#innerFlameGradient)"
        stroke="#FFFFFF"
        strokeWidth="0.3"
      />

      {/* Additional bright core */}
      <ellipse
        cx="12"
        cy="10"
        rx="1"
        ry="2"
        fill="#FFFFFF"
        opacity="0.8"
      />
    </svg>
  );
};
